import { CalendarIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { MilestoneChips } from './MilestoneChips';
import PurchaseOrderStatusChip from '../../features/purchaseOrders/PurchaseOrderStatusChip';
import { formatPrice, getTotalOwedTextColor } from '../../helpers/common';

export const MobilePOCard = ({
    po,
    selected,
    selectable,
    onToggleSelect,
    onOpen,
    pastDueVisible,
    testId
}) => {
    return (
        <div
            onClick={onOpen}
            data-testid={testId}
            className={`px-3 py-3 cursor-pointer transition-colors active:bg-gray-100 ${selected ? 'bg-gray-100' : 'bg-white'}`}
        >
            <div className="flex items-center gap-2.5">
                {selectable && (
                    <div onClick={(e) => e.stopPropagation()} className="flex items-center">
                        <input
                            type="checkbox"
                            checked={!!selected}
                            onChange={onToggleSelect}
                            aria-label={`Select ${po.poNumber}`}
                            className="h-5 w-5 rounded border-gray-300 text-primary focus:ring-primary"
                        />
                    </div>
                )}
                <span className="font-bold text-base text-gray-900">{po.poNumber}</span>
                {po.pastDueDays > 0 && pastDueVisible && (
                    <span className="px-1.5 py-0.5 rounded-full bg-red-600 text-white text-[11px] font-semibold whitespace-nowrap">
                        {po.pastDueDays}d past due
                    </span>
                )}
                <PurchaseOrderStatusChip
                    status={po.status}
                    className="ml-auto capitalize"
                />
            </div>
            <div className="mt-1.5 pl-[30px] text-[13px] text-gray-500">
                <div className="truncate">{po.vendor}</div>
                <div className="mt-0.5 flex items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                        <CalendarIcon className="h-3 w-3" /> {po.poDate || 'N/A'}
                    </span>
                    <span className="inline-flex items-center gap-1 truncate">
                        <DocumentTextIcon className="h-3 w-3" /> {po.invoice || 'N/A'}
                    </span>
                </div>
            </div>
            <div className="mt-1.5 pl-[30px] flex items-center gap-4 text-[13px]">
                <span className="text-gray-900">
                    Paid: <span className="font-semibold">${formatPrice(po.amountPaid)}</span>
                </span>
                <span className={getTotalOwedTextColor(po.amountOwed)}>
                    Owed: <span className="font-semibold">${formatPrice(po.amountOwed)}</span>
                </span>
            </div>
            <div className="mt-2 pl-[30px]">
                <MilestoneChips po={po} />
            </div>
        </div>
    );
};
